import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      padding: '30px 47px',
      maxHeight: '50vh',
      overflowY: 'scroll',
      color: theme.custom.colors.primary,
    },
    customInput: {
      width: 401,
      marginBottom: 30,
    },
    selectAppIcon: {
      marginTop: 31,
      '& div:first-child>label': {
        font: theme.custom.font.paragraph3,
      },
      '& div:nth-child(2)': {
        marginTop: 8,
        width: '186px',
        height: '186px',
        '& label': {
          font: 'normal normal 600 14px/16px Public-Sans',
          color: theme.custom.colors.placeholder,
        }
      },
      '& img': {
        maxWidth: '186px',
        maxHeight: '186px'
      },
    },
    footerModal: {
      height: '15.3%',
      padding: '16px 24px',
      display: 'flex',
      boxShadow: '1px 1px 6px rgba(56, 25, 81, 0.25)',
      justifyContent: 'flex-end',
      alignItems: 'center',
      '& div:first-child': {
        marginRight: 24,
        cursor: 'pointer',
        font: 'normal normal 500 16px/24px Public-Sans',
        color: theme.custom.colors.primary,
      }
    },
    btnAddRecipeBody: {
      '& button': {
        height: 32,
        background: theme.custom.colors.primary,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '&>span:first-child': {
          color: theme.custom.colors.white,
          font: theme.custom.font.montserrat16Bold,
        },
        '&:hover': {
          background: theme.custom.colors.primary,
        },
      },
    },
    backButton: {
      color: "black",
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      backgroundColor: "#D2D2D2",
      borderRadius: "100px",
      border: "none",
      cursor: "pointer",
    },

    cancelButton: {
      color: "black",
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      backgroundColor: "transparent",
      borderRadius: "100px",
      border: "none",
      cursor: "pointer",
      marginRight: 10,
    },
    nextButton: {
      textAlign: "center",
      fontFamily: "Montserrat",
      fontSize: "16px",
      fontWeight: 900,
      lineHeight: "normal",
      padding: "7px 16px",
      border: "none",
      backgroundColor: "#0C85F4",
      borderRadius: "100px",
      color: "white",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginLeft: "24px",
      cursor: "pointer",
      width: 95
    },
    nextButtonIconContainer: {
      marginLeft: "7px",
    },
  };
});

export default useStyles;
